import { render, staticRenderFns } from "./CommentDeleteForm.vue?vue&type=template&id=3f1907d3"
import script from "./CommentDeleteForm.vue?vue&type=script&lang=js"
export * from "./CommentDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports